var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { useCallback, useMemo, useRef, useState, } from "react";
import { previewOptionsToPreviewConfig, } from "./previewOptions";
import { useProductConfigResolver, } from "./hooks/useProductConfigResolver";
import { useVortexPreview } from "./hooks/useVortexPreview";
import { vortexContext } from "./vortexContext";
import { ErrorBoundary } from "./ErrorBoundary";
function InnerVortexContainer({ user, productConfig, renderingInstructionsUrl, children, initializationOptions, cameraOptions, environmentOptions, onError, preserveCamera = false, vortexDocumentAdapter, onBeforeUpdate, onAfterUpdate, }) {
    const [updatingCanvas, setUpdatingCanvas] = useState({ updating: false });
    const vortexCanvasRef = useRef(null);
    const resolvedProductConfig = useProductConfigResolver(productConfig, onError);
    const previewConfig = useMemo(() => {
        if (vortexCanvasRef.current) {
            return previewOptionsToPreviewConfig({
                partialCameraOptions: cameraOptions || {},
                partialEnvironmentOptions: environmentOptions || {},
                canvas: vortexCanvasRef.current,
            });
        }
        return undefined;
        // vortexCanvasRef.current should be in the dependencies
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [cameraOptions, environmentOptions, vortexCanvasRef.current]);
    const onBeforeVortexUpdate = useCallback(() => {
        onBeforeUpdate === null || onBeforeUpdate === void 0 ? void 0 : onBeforeUpdate();
        setUpdatingCanvas({ updating: true });
    }, [onBeforeUpdate]);
    const onAfterVortexUpdate = useCallback((error) => {
        onAfterUpdate === null || onAfterUpdate === void 0 ? void 0 : onAfterUpdate(error);
        setUpdatingCanvas({ updating: false, error });
        if (error) {
            onError(error);
        }
    }, [onAfterUpdate, onError]);
    const { preview } = useVortexPreview({
        previewConfig,
        initializationOptions,
        productConfig: resolvedProductConfig === null || resolvedProductConfig === void 0 ? void 0 : resolvedProductConfig.resolved,
        onError,
        onBeforeVortexUpdate,
        onAfterVortexUpdate,
        renderingInstructionsUrl,
        preserveCamera,
        user,
        vortexDocumentAdapter,
    });
    const loadingConfig = !(resolvedProductConfig === null || resolvedProductConfig === void 0 ? void 0 : resolvedProductConfig.resolved);
    const loadingVortex = !preview;
    const loadingModel = (loadingConfig || loadingVortex) && !(resolvedProductConfig === null || resolvedProductConfig === void 0 ? void 0 : resolvedProductConfig.error);
    const contextValue = {
        vortexCanvasRef,
        preview,
        loadingModel,
        updatingCanvas: updatingCanvas.updating,
        error: (resolvedProductConfig === null || resolvedProductConfig === void 0 ? void 0 : resolvedProductConfig.error) || updatingCanvas.error,
    };
    return (React.createElement(vortexContext.Provider, { value: contextValue }, typeof children === "function" ? children(contextValue) : children));
}
export function VortexContainer(props) {
    const { fallback, onError } = props, rest = __rest(props, ["fallback", "onError"]);
    return (React.createElement(ErrorBoundary, { fallback: fallback, onError: onError },
        React.createElement(InnerVortexContainer, Object.assign({}, rest, { onError: onError }))));
}
//# sourceMappingURL=VortexContainer.js.map